import React from 'react';
import './Modal.css';
import { ApButtonIcon, colors } from '@alixpartners/ui-components';

const Modal = ({ heading, handleClose, show, children }) => {
	const showHideClassName = show ? 'modal display-block' : 'modal display-none';

	return (
		<div className={showHideClassName}>
			<section className="modal-main">
				<section className="modal-header">
					<div style={{ color: `${colors.grey5}` }}>{heading}</div>
					<div>
						<ApButtonIcon
							title="Close"
							iconName="close"
							onClick={handleClose}
						/>
					</div>
				</section>
				{children}
			</section>
		</div>
	);
};
export default Modal;
